import axios from 'axios'

const data = {}

async function getSettingsDown () {
  try {
    let rs = await axios('/down', {params: {'ts': Date.now()}});

    data.title = rs.data.title.length ? rs.data.title : 'Сервис на обновлении';
    data.message = rs.data.message.length ? rs.data.message : 'Производим плановые работы по обновлению компонентов, совсем скоро вернемся к вам';
    data.image = rs.data.image.length ? rs.data.image : '../assets/images/downtime.webp';
    data.canClose = rs.data.canClose;
    data.downTo = rs.data.downTo;
    return data;
  } catch (err) {
    console.log(err);
  }
}

export {getSettingsDown}